import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { keystore } from "@/keystore";
import { PasswordInput } from "@/components/PasswordInput";
import { AppShell } from "@/components/AppShell";

/**
 * Configurações da conta. Por enquanto:
 *  - Exportar private key (pra backup ou import na MetaMask)
 *  - Apagar keystore local (cuidado!)
 */
export default function Settings() {
  const [password, setPassword] = useState("");
  const [exported, setExported] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function onExport(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const priv = await keystore.exportPrivateKey(password);
      setExported(priv);
    } catch (err: any) {
      setError(err.message ?? "Erro");
    }
  }

  async function onDestroy() {
    if (!confirm("Tem certeza? Sem a chave deste device E backup, você PERDE acesso.")) return;
    if (!confirm("Mesmo? Última chance.")) return;
    await keystore.destroy();
    alert("Keystore deletado. Faça login de novo se quiser recriar.");
    window.location.href = "/login";
  }

  return (
    <AppShell>
      <div className="max-w-2xl mx-auto p-6">
        <Link to="/dashboard" className="text-sm underline text-app-muted hover:text-app-accent">
          ← voltar
        </Link>
        <h1 className="text-2xl font-bold my-4">Configurações</h1>

        <section className="app-card p-5 mb-6">
          <h2 className="text-lg font-semibold mb-2">Exportar chave</h2>
          <p className="text-sm text-app-muted mb-3">
            Salve isso em local seguro (gerenciador de senhas, papel num cofre, etc).
            Você pode importar essa chave em outro device ou na MetaMask.
          </p>
          <form onSubmit={onExport} className="flex gap-2 items-stretch">
            <div className="flex-1">
              <PasswordInput placeholder="Sua senha"
                             value={password} onChange={(e) => setPassword(e.target.value)}
                             autoComplete="current-password" />
            </div>
            <button type="submit"
                    className="bg-app-accent text-app-accent-text rounded px-4 font-medium hover:opacity-90">
              Exportar
            </button>
          </form>
          {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
          {exported && (
            <div className="mt-4">
              <p className="text-xs text-amber-500 mb-2">
                🚨 Não compartilhe esta chave. Não cole em sites suspeitos.
              </p>
              <pre className="bg-app-surface-2 border border-app-border p-3 rounded text-xs break-all">{exported}</pre>
            </div>
          )}
        </section>

        <section className="app-card border-red-500/40 bg-red-500/5 p-5">
          <h2 className="text-lg font-semibold mb-2 text-red-500">Zona de perigo</h2>
          <p className="text-sm text-app-muted mb-3">
            Apagar keystore: remove o blob criptografado deste device. Pra recuperar
            depois você precisa do private key exportado anteriormente.
          </p>
          <button onClick={onDestroy}
                  className="bg-red-500 text-white rounded px-4 py-2 hover:opacity-90">
            Apagar keystore deste device
          </button>
        </section>
      </div>
    </AppShell>
  );
}
